import { toggleScrollbar } from '../../scripts/utils/toggleScrollbar';
import './modals.scss';

$('[data-role="modal-trigger"]').fancybox({
  beforeShow() {
    console.log('open');
    toggleScrollbar(true);
  },
  afterClose() {
    console.log('close');
    toggleScrollbar(false);
  },
});

$('[data-modal="pop-up-card"]').on('click', (e) => {
  e.preventDefault();
  $.fancybox.open({
    src: '#pop-up-card',
    type: 'inline',
    autoFocus: false,
    touch: false,
    beforeShow() {
      toggleScrollbar(true);
    },
    afterClose() {
      toggleScrollbar(false);
    },
  });
});
